import { Link } from 'react-router-dom';
import styles from './CreateSelectionButton.module.less';

function CreateSelectionButton(props: { linkTo: string, style?: any, className?: string }) {
  return (
    <Link className={props.className} style={props.style} to={props.linkTo}>
      <button className={`${styles['create-selection-btn']} border-secondary border-2 rounded-lg h-10 w-40 hover:bg-secondary hover:text-primary`}>
        Crear
      </button>
    </Link>
  );
}

export default CreateSelectionButton;
